import { useParams } from "react-router-dom";
import {
  ComplianceObjectType,
  GetComplianceCasesByObjectIdQuery,
} from "../../graphql/supergraph.index";

interface ProfileRelationshipType {
  __typename?: "ProfileRelationshipType";
  id: number;
  percentOwnership: number | null;
  childProfile: {
    __typename?: "ProfileType";
    id: number;
    complianceObjectType: ComplianceObjectType;
    firstName: string | null;
    lastName: string | null;
    middleName: string | null;
    legalName: string | null;
    addresses: Array<{
      __typename?: "ProfileAddressType";
      street: string | null;
      street2: string | null;
      street3: string | null;
      state: { __typename?: "StateType"; id: number; name: string } | null;
      country: { __typename?: "CountryType"; id: number; name: string } | null;
    }>;
  };
}
interface ComplianceProfile {
  id: number;
  firstName?: string | null;
  middleName?: string | null;
  lastName?: string | null;
  dateOfBirth?: string | null;
  taxIdUnencryptedLast4Digits?: string | null;
  legalName?: string | null;
  controllingPersons: Array<ProfileRelationshipType>;
  beneficialOwners: Array<ProfileRelationshipType>;
  addresses?: Array<{
    id: number;
    street?: string | null;
    street2?: string | null;
    street3?: string | null;
    city?: string | null;
    state?: { id: number; code: string } | null;
    province?: string | null;
    subprovince?: string | null;
    postalCode?: string | null;
    country?: { id: number; alpha2code: string } | null;
  }>;
}

export default function useProfile(caseResult: GetComplianceCasesByObjectIdQuery | undefined) {
  const { profileId } = useParams<{ profileId: string }>();

  const allProfiles = caseResult?.complianceCasesByObjectId[0].profiles.concat([
    caseResult?.complianceCasesByObjectId[0].investingProfile,
  ]);
  return allProfiles?.filter((p) => p?.id === parseInt(profileId))[0] as
    | ComplianceProfile
    | undefined;
}
